import styles from "./Filters.module.css";

export const FILTERS = ["all", "easy", "medium", "hard", "verified", "unverified", "errors"];

export default function Filters({ value, onChange }) {
  return (
    <div id="qa-filters" className={styles.filters} role="group" aria-label="Filter questions">
      {FILTERS.map((f) => (
        <button
          key={f}
          type="button"
          className={`${styles.filter} ${value === f ? styles.on : ""}`}
          aria-pressed={value === f}
          onClick={() => onChange(f)}
        >
          {f}
        </button>
      ))}
    </div>
  );
}
